import { getRequest } from 'utils/api/apiRequest'
import { WithPagination } from 'utils/api/pagination'

export type Charity = {
  id: number
  name: string
}

export const getCharity = () => getRequest<WithPagination<Charity>>(`/redemption-site/charity?limit=100`)
